var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackoutCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 77.8515,
    height: 78,
    viewBox: "0 0 77.8515 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 289656"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M68.7864 78L1.78125 65.8477L16.2033 1.35083L77.8515 21.2245C73.1467 48.1053 70.6215 72.8847 68.7859 78H68.7864Z",
    fill: "#000066"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.3249 75.9995L0 61.2149C3.84834 56.6457 8.54426 33.7695 13.1967 11.8304C13.5921 9.96465 13.8859 8.07875 14.0775 6.18105L14.7002 0L77 14.0188L76.434 19.3469C76.1417 22.0995 75.6323 24.8246 74.9133 27.496C69.1689 48.8419 63.9016 69.0718 64.3249 75.9995Z",
    fill: "#1D72F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.9688 53.4345C30.8704 53.4345 30.771 53.4231 30.6732 53.3999C30.239 53.2975 29.8888 52.9771 29.7476 52.5537L22.0216 29.3746C21.7965 28.6999 22.1612 27.9706 22.8359 27.746C23.5111 27.5209 24.2399 27.8856 24.4644 28.5603L31.5317 49.7628L56.3281 24.9664C56.8313 24.4637 57.6461 24.4637 58.1493 24.9664C58.652 25.469 58.652 26.2843 58.1493 26.7875L31.8799 53.0569C31.6358 53.3011 31.3061 53.4345 30.9688 53.4345Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackoutCreated);
export default __webpack_public_path__ + "static/media/blackout-created.70b21395094f4c9d5e03c015d3e7fe55.svg";
export { ForwardRef as ReactComponent };